import {
    FormattedDashboardVerificationService,
    DashboardVerificationService
} from "@idw-types/data/dashboard";
import { RpServiceType } from "@idw-types/data/reference-data/generic";

export const formatDashboardVerificationServices = (
    verificationServices: Array<DashboardVerificationService>,
    rpServiceTypes: Array<RpServiceType>
): Array<FormattedDashboardVerificationService> => {
    return verificationServices.map(service => formatDashboardVerificationService(service, rpServiceTypes));
};

export const formatDashboardVerificationService = (
    verificationService: DashboardVerificationService,
    rpServiceTypes: Array<RpServiceType>
): FormattedDashboardVerificationService => {
    
    let changeRequestDate = null;
    if (verificationService.changeRequestDate) {
        changeRequestDate = new Date(parseInt(verificationService.changeRequestDate));
    }

    const serviceType = rpServiceTypes.find(st => st.key === verificationService.serviceType);

    return {
        apiKey: verificationService.apiKey,
        changeRequestDate: changeRequestDate,
        changeRequestStatus: verificationService.changeRequestStatus,
        rpServiceID: verificationService.rpServiceID,
        serviceName: verificationService.serviceName,
        serviceType: serviceType
    };
};